/* eslint-env browser */

import * as React from 'react'
import PropTypes from 'prop-types'
import withTranslator from '../TranslatorProvider'
const { captureException } = require('../../services/sentry-service')

const moment = require('moment')
const axios = require('axios')
const classNames = require('classnames')

const EmptyData = require('../EmptyData')
const EmptyImagesGenerator = require('../../../../../../shared/services/empty-images-generator')

class CommentsList extends React.PureComponent {
  constructor() {
    super()
    this.postComment = this.postComment.bind(this)
    this.onLoadMore = this.onLoadMore.bind(this)
    this.updateComments = this.updateComments.bind(this)
    this.state = {
      input: '',
      comments: [],
    }
  }

  componentWillMount() {
    const { comments, totalCommentsCount, mostRecentOnTop } = this.props
    if (comments) {
      this.setState({
        comments: comments.sort((a, b) =>
          mostRecentOnTop
            ? new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            : new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        ),
      })
    }
    if (typeof totalCommentsCount !== 'undefined') {
      this.setState({ totalCommentsCount })
    }
  }

  onLoadMore() {
    const { commentable, commentableId, mostRecentOnTop } = this.props
    const { comments } = this.state

    let firstComment = comments[0]
    if (mostRecentOnTop) {
      firstComment = comments[comments.length - 1]
    }
    this.setState({ loadingMore: true })
    return axios
      .get(`/api/comments/${commentable}/${commentableId}`, {
        params: {
          before: new Date(firstComment.createdAt).getTime(),
          limit: 10,
        },
      })
      .then(res => {
        this.setState({ totalCommentsCount: parseFloat(res.headers['x-total-count']) })
        this.updateComments(res.data)
      })
      .catch(err => {
        captureException(err)
        this.setState({ loadingMore: false })
      })
  }

  updateComments(newComments) {
    const { mostRecentOnTop } = this.props
    const { comments } = this.state

    const existingCommentsIds = comments.map(elt => elt.id)
    const newCommentsFiltered = newComments.filter(elt => existingCommentsIds.indexOf(elt.id) === -1)
    this.setState({
      comments: comments
        .concat(newCommentsFiltered)
        .sort((a, b) =>
          mostRecentOnTop
            ? new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
            : new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
        ),
      loadingMore: false,
    })
  }

  postComment(e) {
    e.preventDefault()

    const { commentable, commentableId } = this.props
    const { input, comments } = this.state

    if (input.trim().length === 0) {
      this.setState({ input: '' })
    }

    this.setState({ sendingComment: true })
    axios
      .post('/api/comments/', {
        commentable,
        commentableId,
        comment: input,
      })
      .then(() => {
        let lastComment
        if (comments.length > 0) {
          lastComment = comments[comments.length - 1]
        }
        return axios
          .get(`/api/comments/${commentable}/${commentableId}`, {
            params: {
              after: lastComment ? new Date(lastComment.createdAt).getTime() : undefined,
              limit: 10,
            },
          })
          .then(res => {
            this.setState({ totalCommentsCount: parseFloat(res.headers['x-total-count']) })
            this.updateComments(res.data)
          })
      })
      .then(() => {
        this.setState({ sendingComment: false, input: '' })
      })
      .catch(err => {
        captureException(err)
        this.setState({ sendingComment: false })
      })
    return false
  }

  render() {
    const { locale, translate, opCreatorId, isLoggedIn, mostRecentOnTop, commentableId } = this.props
    const { totalCommentsCount, comments, loadingMore, sendingComment, input } = this.state

    const canLoadMore = totalCommentsCount > comments.length

    const moreButton = (
      <button
        type="button"
        onClick={this.onLoadMore}
        className="button is-white is-small has-margin-bottom-xxsmall has-text-blueTitle"
        disabled={loadingMore}
      >
        {translate('comments.loadMore')}
      </button>
    )

    const inputCommentElement = (
      <div className="media">
        <form onSubmit={this.postComment} style={{ width: '100%' }}>
          <div className="media-content">
            <div className="field has-addons">
              <div className="control" style={{ flex: 1 }}>
                <input
                  type="text"
                  className="input is-rounded is-small"
                  placeholder={translate('comments.inputPlaceholder')}
                  disabled={!isLoggedIn || sendingComment}
                  value={input}
                  onChange={elt => this.setState({ input: elt.target.value })}
                />
              </div>
              <div className="control">
                <button
                  type="submit"
                  className="button is-call-to-action is-small"
                  disabled={!isLoggedIn || sendingComment || input.trim().length === 0}
                >
                  {translate('comments.send')}
                </button>
              </div>
            </div>
          </div>
          {!isLoggedIn && <small>{translate('comments.shouldBeConnected')}</small>}
        </form>
      </div>
    )

    return (
      <div className="comments-list">
        <meta itemProp="commentCount" content={totalCommentsCount} />
        {canLoadMore && !mostRecentOnTop && moreButton}

        {totalCommentsCount === 0 && (
          <div className="has-text-centered has-padding-small">
            <EmptyData emptyableId={commentableId} subtitle={translate('comments.empty')} isSmall />
          </div>
        )}

        {mostRecentOnTop && inputCommentElement}

        {comments.map((elt, idx) => {
          let avatarUrl = elt.commentator.fbProfilePictureUrl
          if (elt.commentator.profilePicture) {
            avatarUrl = elt.commentator.profilePicture.url
          }
          if (!avatarUrl) {
            avatarUrl = EmptyImagesGenerator.getUserPlaceholder({ userId: elt.commentator.id })
          }
          const commentatorFullName = `${elt.commentator.firstName.trim()} ${elt.commentator.lastName.trim()}`
          return (
            <div key={elt.id} className="media" itemProp="comment" itemScope itemType="http://schema.org/Comment">
              <div className="media-left">
                <figure
                  className={classNames('image is-48x48 is-square', {
                    'badge is-badge-small is-badge-success is-badge-bottom': elt.commentator.id === opCreatorId,
                  })}
                  data-badge=""
                >
                  <img
                    src={avatarUrl}
                    className={classNames('has-object-fit-cover is-rounded has-border-white')}
                    alt={commentatorFullName}
                  />
                </figure>
              </div>
              <div className="media-content">
                <div className="content is-size-7">
                  <a
                    href={`/users/${elt.createdBy}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    itemProp="author"
                    itemScope
                    itemType="https://schema.org/Person"
                  >
                    <strong itemProp="name">{commentatorFullName}</strong>
                  </a>
                  &nbsp;
                  <small
                    className={classNames('tooltip', { 'tooltip-bottom': idx === 0 }, { 'tooltip-top': idx > 0 })}
                    data-tooltip={new Date(elt.createdAt).toLocaleString()}
                  >
                    <time dateTime={new Date(elt.createdAt).toISOString()} itemProp="dateCreated">
                      {moment(new Date(elt.createdAt))
                        .locale(locale)
                        .fromNow()}
                    </time>
                  </small>
                  <br />
                  <p itemProp="text">{elt.comment}</p>
                </div>
              </div>
            </div>
          )
        })}
        {!mostRecentOnTop && inputCommentElement}
        {canLoadMore && mostRecentOnTop && moreButton}
      </div>
    )
  }
}

CommentsList.propTypes = {
  translate: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  isLoggedIn: PropTypes.bool,
  commentable: PropTypes.string.isRequired,
  commentableId: PropTypes.string.isRequired,
  comments: PropTypes.array.isRequired,
  totalCommentsCount: PropTypes.number,
  opCreatorId: PropTypes.string,
  mostRecentOnTop: PropTypes.bool,
}

CommentsList.defaultProps = {
  isLoggedIn: false,
  totalCommentsCount: 0,
  opCreatorId: undefined,
  mostRecentOnTop: false,
}

module.exports = withTranslator(CommentsList)
